// @generated
// This file was automatically generated and should not be edited.
// Run `dev generate pipeline-frontend` to regenerate.

/* eslint-disable unused-imports/no-unused-imports */

// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {ColumnTypeValidationFlag} from 'data-frames/util/validateColumnType';
// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {LeafType} from 'data-types/benchling-type-def/BenchlingTypeDef';
// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {PipelineStepDataKind, PipelineStepType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {PipelineStepShape} from 'pipelines/StepShapeUtils';

export const PROCEDURE_RUN_DATA_FRAMES_STEP_SHAPES = [
  {
    stepType: PipelineStepType.PROCEDURE_RUN_DATA_FRAMES,
    isDeprecated: true,
    version: 0,
    inputDataShapes: {},
    outputDataShapes: {
      CONDITION_REPLICATE_CONFIRMATION: {
        systemName: 'CONDITION_REPLICATE_CONFIRMATION',
        displayName: 'Condition replicate confirmation',
        kind: PipelineStepDataKind.DATASET,
        isMulti: false,
        isRequired: true
      },
      DATA_PARAMETER_ACTUAL: {
        systemName: 'DATA_PARAMETER_ACTUAL',
        displayName: 'Actual data parameters',
        kind: PipelineStepDataKind.DATASET,
        isMulti: false,
        isRequired: true
      },
      MATERIAL_PARAMETER_CONFIRMATION: {
        systemName: 'MATERIAL_PARAMETER_CONFIRMATION',
        displayName: 'Material parameter confirmation',
        kind: PipelineStepDataKind.DATASET,
        isMulti: false,
        isRequired: true
      },
      RESULTS: {
        systemName: 'RESULTS',
        displayName: 'Results',
        kind: PipelineStepDataKind.DATASET,
        isMulti: true,
        isRequired: false
      },
      ENTITIES: {
        systemName: 'ENTITIES',
        displayName: 'Entities',
        kind: PipelineStepDataKind.DATASET,
        isMulti: true,
        isRequired: false
      }
    },
    config: {
      procedureRunConfigs: {
        kind: 'array',
        required: true,
        elementSpec: {
          kind: 'shape',
          required: true,
          fields: {
            procedureRunId: {
              kind: 'domain',
              required: true,
              types: [
                'PROCEDURE_RUN'
              ]
            }
          }
        }
      }
    }
  }
] as const satisfies ReadonlyArray<PipelineStepShape>;
